import { useEffect, useState } from "react";
import NivoPieChart from "../../../Nivo/Nivo_Piechart";
import { baseURL } from "../../../Util/axios_helper";
import { useDispatch, useSelector } from "react-redux";
import StackedBarChart from "../../../ChartsJs/StatckedBar";
import { downloadPDF } from "../../../ChartsJs/DownlaodExportImage";
import { KendoGrid } from "../../../Kendo/kendo_grid";
import { PdfModal } from "../../../Util/common";

const Eventdaycharges = ({ year, type, filter, metric, metricvalue }) => {
  const { SalesData } = useSelector((state) => state.sales);

  const [label, setlabel] = useState([]);
  const [data, setData] = useState([]);
  const [legend, setLegend] = useState([]);

  const [minVal, setminVal] = useState(0);
  const [maxVal, setmaxVal] = useState(11);

  function getISOWeekNumber(date) {
    const tempDate = new Date(date);
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 4 - (tempDate.getDay() || 7));
    const yearStart = new Date(tempDate.getFullYear(), 0, 1);
    const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);
    return weekNumber;
  }

  function getMinAndMaxWeekNumbers() {
    const today = new Date();
    const maxWeekNumber = getISOWeekNumber(today);

    const minDate = new Date(today);
    minDate.setDate(today.getDate() - 12 * 7);
    const minWeekNumber = getISOWeekNumber(minDate);

    return { maxWeekNumber, minWeekNumber };
  }

  useEffect(() => {
    if (SalesData && SalesData.Table5) {
      const xAxis = SalesData.Table5.XAxis;
      const legends = SalesData.Table5.legends;
      const data = SalesData.Table5.yAxisData;

      setlabel(xAxis);
      setLegend(legends);
      setData(data);

      if (data.length > 12) {
        const { maxWeekNumber, minWeekNumber } = getMinAndMaxWeekNumbers();
        setmaxVal(maxWeekNumber);
        setminVal(minWeekNumber);
      } else {
        setmaxVal(11);
        setminVal(0);
      }
    }
  }, [SalesData]);

  const [reportcolumn, setreportcolumn] = useState({
    Reportflag: false,
    Roomrental: true,
    Decor: true,
    RDD: true,
    Vendor: true,
    EventdayCharge: true,
    Reschedulingfee: true,
    Beveragesfee: true,
    Adjustments: true,
    Deficit: true,
    title: "",
    exportFName: "",
    refreshflag: 0,
    reportvalue: "",
  });

  return (
    <>
      <div className="card">
        <div className="col-xs-12 mt-2 files">
          {/* <div
            className="ms-2 me-2 "
            title="Export to Pdf"
            style={{
              position: "relative",
              float: "right",
              cursor: "pointer",
            }}
            onClick={() =>
              downloadPDF("eventday", "Event day Charges", 60, 3)
            }
          >
            <span className="files-icon">
              <i class="las la-image"></i>
            </span>
          </div> */}

          <a
            href={`#`}
            onClick={() => {
              var modal = document.getElementById("SEDCPDFmodal");
              modal.style.display = "block";
              var span = document.getElementById("SEDCPDFclose");
              span.onclick = function () {
                modal.style.display = "none";
              };

              // When the user clicks anywhere outside of the modal, close it
              window.onclick = function (event) {
                if (event.target == modal) {
                  modal.style.display = "none";
                }
              };
            }}
          >
            <div
              title="View Report"
              className="ms-2 me-2"
              style={{
                position: "relative",
                float: "right",
                cursor: "pointer",
              }}
            >
              <span className="files-icon">
                <i className="las la-image"></i>
              </span>
            </div>
          </a>
          {/* Trigger button for modal */}
          <a
            href={`#`}
            onClick={() => {
              var modal = document.getElementById("EdModal");
              modal.style.display = "block";
              var span = document.getElementById("Edcclose");
              span.onclick = function () {
                modal.style.display = "none";
              };

              // When the user clicks anywhere outside of the modal, close it
              window.onclick = function (event) {
                if (event.target == modal) {
                  modal.style.display = "none";
                }
              };

              setreportcolumn((prevreportcolumn) => ({
                ...prevreportcolumn,
                Reportflag: true,
                Roomrental: true,
                Decor: true,
                RDD: true,
                Vendor: true,
                EventdayCharge: false,
                Reschedulingfee: true,
                Beveragesfee: true,
                Adjustments: true,
                Deficit: true,
                title: "Total Event Day Charges Sales Report",
                exportFName: "Sales_EventDayCharges_Report",
                refreshflag: reportcolumn.refreshflag + 1,
                reportvalue: "eventday",
              }));
            }}
          >
            <div
              title="View Report"
              className=""
              style={{
                position: "relative",
                float: "right",
                cursor: "pointer",
              }}
            >
              <span className="files-icon">
                <i className="las la-file-alt"></i>
              </span>
            </div>
          </a>
        </div>

        <div className="card-body">
          <div style={{ height: 400, fontWeight: "bold" }}>
            <div style={{ textAlign: "center" }}>Event Day Charges</div>
            {SalesData && (
              <StackedBarChart
                data={data}
                type={"bar"}
                labels={label}
                legend={legend}
                titl={year}
                XAxisLabel={type}
                YAxisLabel={"Sales"}
                id={"eventday"}
                chartType={"eventdaychart"}
                countOnLead={false}
                minVal={minVal}
                maxVal={maxVal}
                dollar={true}
              />
            )}
          </div>
        </div>
        {/* <!-- eventday Report Modal --> */}
        <div id="EdModal" class="cmodal">
          <div class="cmodal-content">
            <div className="modal-header">
              <h5 className="modal-title-popup">{reportcolumn.title}</h5>
              <span class="close" id="Edcclose">
                &times;
              </span>
            </div>
            <div className="row">
              <div className="col-md-12">
                {reportcolumn.Reportflag && (
                  <KendoGrid
                    exportFileName={reportcolumn.exportFName}
                    name={"Ed_Sales_report"}
                    paggable={true}
                    url={`${baseURL}Analytics/Get_SalesData_Report?type=${type}&years=${year}&filter=${filter}&metrics=${metric}&value=${metricvalue}&reportType=${reportcolumn.reportvalue}`}
                    schema={{
                      RoomRentalcharges: { type: "number" },
                      
                      DecorationServicesCharges: { type: "number" },
                      RDDCharges: { type: "number" },
                      VendorServicesCharges: { type: "number" },
                      ReschedulingFeeCharges: { type: "number" },
                      Chargeofthedaycharges: { type: "number" },
                      BeverageFeeCharges: { type: "number" },
                      FunctionTotal: { type: "number" },
                      EstimatedAttendance: { type: "number" },
                    }}
                    refreshWhen={reportcolumn.refreshflag}
                    columns={[
                      {
                        field: "EventNumber",
                        title: "Event No",
                        width: 100,
                      },
                      {
                        field: "FunctionNumber",
                        title: "Function No",
                        width: 110,
                      },
                      {
                        field: "EventName",
                        title: "Event Name",
                        width: 150,
                      },
                      {
                        field: "EventType",
                        title: "EventType",
                        width: 100,
                      },
                      {
                        field: "GuaranteedDate",
                        title: "Guaranteed Date",
                        width: 150,
                      },
                      {
                        field: "FunctionStartDate",
                        title: "StartDate",
                        width: 150,
                      },
                      {
                        field: "FunctionEndDate",
                        title: "EndDate",
                        width: 150,
                      },
                      {
                        field: "EstimatedAttendance",
                        title: "Estimated Attendance",
                        width: 150,
                      },
                      {
                        field: "FunctionTotal",
                        title: "Function Total",
                        width: 150,
                      },
                      {
                        field: "TypeofContract",
                        title: "Type of Contract",
                        width: 150,
                      },
                      {
                        field: "ContactPerson",
                        title: "Contact Person",
                        width: 150,
                      },
                     
                      {
                        field: "PrimaryContactEmail",
                        title: "Primary Contact Email",
                        width: 150,
                      },
                      {
                        field: "RoomRentalcharges",
                        title: "Room Rental charges",
                        width: 150,
                        hidden: reportcolumn.Roomrental,
                      },
                      {
                        field: "DecorationServicesCharges",
                        title: "Decor Charges",
                        width: 150,
                        hidden: reportcolumn.Decor,
                      },
                      {
                        field: "RDDCharges",
                        title: "RDD harges",
                        width: 150,
                        hidden: reportcolumn.RDD,
                      },
                      {
                        field: "VendorServicesCharges",
                        title: "Vendor Charges",
                        width: 150,
                        hidden: reportcolumn.Vendor,
                      },
                      {
                        field: "ReschedulingFeeCharges",
                        title: "Rescheduling Charges",
                        width: 150,
                        hidden: reportcolumn.Reschedulingfee,
                      },
                      {
                        field: "Chargeofthedaycharges",
                        title: "EventDay Charges",
                        width: 150,
                        hidden: reportcolumn.EventdayCharge,
                      },
                      {
                        field: "BeverageFeeCharges",
                        title: "Beverage Charges",
                        width: 150,
                        hidden: reportcolumn.Beveragesfee,
                      },
                      {
                        field: "FunctionLocation",
                        title: "Function Location",
                        width: 150,
                      },
                      {
                        field: "ReferralType",
                        title: "Referral Type",
                        width: 150,
                      },
                      {
                        field: "Culture",
                        title: "Culture",
                        width: 150,
                      },
                      {
                        field: "Salesperson",
                        title: "Salesperson",
                        width: 150,
                      },
                      {
                        field: "CreationDate",
                        title: "Creation Date",
                        width: 150,
                      },
                      {
                        field: "LastUpdated",
                        title: "Last Updated",
                        width: 150,
                      },
                    ]}
                    height={400}
                    showOptions={false}
                    showEdit={false}
                    showDelete={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End EventDay Report Modal/ --> */}

        {/* <!-- EDC PDF Modal --> */}
        <PdfModal
          chart={
            SalesData && (
              <StackedBarChart
                data={data}
                type={"bar"}
                labels={label}
                legend={legend}
                titl={year}
                XAxisLabel={type}
                YAxisLabel={"Sales"}
                id={"PDFeventday"}
                chartType={"eventdaychart"}
                countOnLead={false}
                minVal={minVal}
                maxVal={maxVal}
                dollar={true}
                ChartHeight={600}
                ValueFontSize={12}
              />
            )
          }
          modalId={"SEDCPDFmodal"}
          modalcloseId={"SEDCPDFclose"}
          modalTitle={"Event Day Charges"}
          PDFDownload={() =>
            downloadPDF("PDFeventday", "Event day Charges", 90, 3)
          }
        />
        {/* <!-- End EDC PDF Modal/ --> */}
      </div>
    </>
  );
};

export default Eventdaycharges;
